import { render, staticRenderFns } from "./WalletPayment.vue?vue&type=template&id=09cd6372"
import script from "./WalletPayment.vue?vue&type=script&lang=ts"
export * from "./WalletPayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports